/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Not_AuthenticatedInputs */

const en_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must be signed in.`)
};

const es_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debes iniciar sesión.`)
};

const fr_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez être connecté.`)
};

const de_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du musst angemeldet sein.`)
};

const ja_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインする必要があります。`)
};

const zh_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您必须先登录。`)
};

const ar_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب عليك تسجيل الدخول.`)
};

const id_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda harus masuk terlebih dahulu.`)
};

const it_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devi effettuare l'accesso.`)
};

const ru_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы должны быть авторизованы.`)
};

const pt_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você deve estar logado.`)
};

const ko_error_not_authenticated = /** @type {(inputs: Error_Not_AuthenticatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인해야 합니다.`)
};

/**
* | output |
* | --- |
* | "You must be signed in." |
*
* @param {Error_Not_AuthenticatedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_not_authenticated = /** @type {((inputs?: Error_Not_AuthenticatedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Not_AuthenticatedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_not_authenticated(inputs)
	if (locale === "es") return es_error_not_authenticated(inputs)
	if (locale === "fr") return fr_error_not_authenticated(inputs)
	if (locale === "de") return de_error_not_authenticated(inputs)
	if (locale === "ja") return ja_error_not_authenticated(inputs)
	if (locale === "zh") return zh_error_not_authenticated(inputs)
	if (locale === "ar") return ar_error_not_authenticated(inputs)
	if (locale === "id") return id_error_not_authenticated(inputs)
	if (locale === "it") return it_error_not_authenticated(inputs)
	if (locale === "ru") return ru_error_not_authenticated(inputs)
	if (locale === "pt") return pt_error_not_authenticated(inputs)
	return ko_error_not_authenticated(inputs)
});